import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const phone = '573174343442';
  const message = 'Hola, necesito ayuda con el pago de sistematización';

  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contactar por WhatsApp"
    >
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.164 0 0 7.164 0 16c0 2.832.748 5.484 2.048 7.78L.704 30.5l7.02-1.844A15.856 15.856 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.332c-2.584 0-5.02-.732-7.076-2.008l-.508-.3-5.248 1.376 1.4-5.116-.332-.528A13.27 13.27 0 012.668 16c0-7.364 5.968-13.332 13.332-13.332S29.332 8.636 29.332 16 23.364 29.332 16 29.332zm7.308-9.972c-.4-.2-2.368-1.168-2.736-1.3-.368-.132-.636-.2-.904.2-.268.4-1.036 1.3-1.268 1.568-.232.268-.468.3-.868.1-.4-.2-1.688-.624-3.216-1.988-1.188-1.06-1.992-2.368-2.224-2.768-.232-.4-.024-.616.176-.816.18-.18.4-.468.6-.7.2-.232.268-.4.4-.668.132-.268.068-.5-.032-.7-.1-.2-.904-2.176-1.236-2.98-.324-.78-.652-.676-.904-.688-.232-.012-.5-.016-.768-.016s-.7.1-1.068.5c-.368.4-1.4 1.368-1.4 3.336s1.436 3.868 1.636 4.136c.2.268 2.832 4.324 6.86 6.064.96.416 1.708.664 2.292.848.964.308 1.84.264 2.532.16.772-.116 2.368-.968 2.7-1.904.332-.936.332-1.736.232-1.904-.1-.168-.368-.268-.768-.468z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
